import { Fragment } from 'react';
import { Stack, Label, ILabelStyles, Separator } from '@fluentui/react';
import { Video } from '../api/generated/data-contracts';
import { createNewGuid } from '../components/Utils';
import { useHelpVideos } from '../Configuration/config/components/HelpConfig/useHelpVideos';

const labelStyles: ILabelStyles = {
    root: { marginTop: 10 },
};

const defaultVideos: Video[] = [
    {
        header: 'Video',
        description: 'Unsure on how to use Time for Teams. Please watch the video below to go through Time for Teams step by step.',
        url: 'https://www.youtube.com/embed/UC9nlBCC3wc',
        source: 'youtube',
        order: 1,
        id: createNewGuid(),
    },
];

function HelpVideos() {
    const { data: videos } = useHelpVideos({ suspense: true });

    return (
        <div style={{ overflowY: 'auto', height: 'calc(100vh - 100px)' }}>
            <Stack horizontalAlign="center">
                {(videos.length ? videos : defaultVideos).map(vid => {
                    return (
                        <Fragment key={vid.id}>
                            <br />
                            <h2>{vid.header}</h2>
                            <Separator styles={{ root: { width: '100%' } }} />
                            <Label styles={labelStyles}>{vid.description}</Label>
                            <iframe width="1248" height="702" src={vid.url} allowFullScreen={true} style={{ border: 'none' }}></iframe>
                        </Fragment>
                    );
                })}
            </Stack>
        </div>
    );
}

export default HelpVideos;
